import { NavLink } from 'react-router'

import { navigation } from '@/config/navigation'
import { useAuthStore } from '@/features/auth/store/auth.store'
import { cn } from '@/lib/utils'

type SidebarNavProps = {
  collapsed?: boolean
  onNavigate?: () => void
}

export function SidebarNav({ collapsed = false, onNavigate }: SidebarNavProps) {
  const roles = useAuthStore((state) => state.user?.roles)

  return (
    <nav className="flex flex-col gap-6 px-3 py-4" aria-label="Main">
      {navigation.map((section) => {
        const items = section.items.filter(
          (item) => !item.roles || (roles ? item.roles.some((role) => roles.includes(role)) : false),
        )
        if (items.length === 0) return null

        return (
          <div key={section.label} className="space-y-1">
            {!collapsed ? (
              <p className="eyebrow px-3 pb-1">{section.label}</p>
            ) : null}
            {items.map(({ label, to, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                onClick={onNavigate}
                title={collapsed ? label : undefined}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-sm px-3 py-2 text-body font-medium transition-colors',
                    'text-sidebar-foreground/80 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
                    'focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none',
                    isActive &&
                      'bg-sidebar-primary/10 text-sidebar-primary hover:bg-sidebar-primary/15 hover:text-sidebar-primary',
                    collapsed && 'justify-center px-2',
                  )
                }
              >
                <Icon className="size-4 shrink-0" aria-hidden />
                {!collapsed ? <span className="truncate">{label}</span> : null}
              </NavLink>
            ))}
          </div>
        )
      })}
    </nav>
  )
}
